<template>
	<div class="bottom-item-editor">
		<AppBottomSheet :forceWidth="bottomSheetWidth" :active="active" @toggling-popup="v => $emit('toggling-popup', v)" >
			<div class="bottom-item-editor-content" v-if="active">
				<ModalHeader :title="title" />
				<AppList :items="items">
					<template #number-input-slot="{item}">
						<div class="row centered space-between">
							<p class="number-p">{{item.title}}</p>
							<TouchNumberInput class="input-item" :min="0" :value="item.value" @changed-value="v=>{item.valueCallback(v)}" />
						</div>
					</template>
					<template #item-total="{item}">
						<div class="row centered space-between">
							<p class="number-p-2">{{item.title}}</p>
							<div class="item-total-container" @click="updatePrice">
								<p class="item-total">{{ currencyStore.readableCurrencyValue(price, true, false) }}</p>
							</div>
						</div>
					</template>
				</AppList>
			</div>
		</AppBottomSheet>
		<BottomNumberEditor :active="priceEdit" :title="title+' ('+currencyStore.currCurrency.symbol+')'" :start-price-name="getString('price')" :starting-number="itemPrice" @toggling-popup="togglingPrice" @confirm-number="confirmPrice" />
	</div>
</template>

<script>
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import WindowWidth from "@/console-new/mixins/WindowWidth";
import {useCurrencyStore, useLanguageStore} from "@/shared/stores";
import {useCounterStore, useUserStore} from "@/console-new/stores";
import AppList from "@/shared/components/AppList.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import AppNumberInput from "@/shared/components/AppNumberInput.vue";
import BottomNumberEditor from "@/console-new/components/ops/counter/BottomNumberEditor.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import TouchNumberInput from "@/console-new/components/shared/TouchNumberInput.vue";

export default {
	setup() {
		let languageStore = useLanguageStore();
		const counterStore = useCounterStore();
		const currencyStore = useCurrencyStore();
		const userStore = useUserStore();
		return {getString: languageStore.getString, counterStore, currencyStore, userStore};
	},
	name: "BottomFakeItemEditor",
	components: {BottomNumberEditor, AppNumberInput, ModalHeader, AppList, AppBottomSheet, AppTextInput, TouchNumberInput},
	mixins: [WindowWidth],
	props: {
		active: {
			type: Boolean,
			default: false
		},
		title: {
			type: String,
			default: ""
		},
		quantity: {
			type: Number,
			default: null
		},
		price: {
			type: Number,
			default: 0
		},
	},
	data() {
		return {
			priceEdit: false,
		}
	},
	computed: {
		itemPrice() {
			if(this.active) {
				return this.price;
			} else {
				return 0;
			}
		},
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else {
				return "720px";
			}
		},
		items() {
			if(!this.active) {
				return [];
			}
			let items = [];
			if(this.quantity !== null) {
				items.push({title: this.getString("quantity"), customSlot: 'number-input-slot', value: this.quantity, valueCallback: v => {
					this.$emit('changed-quantity', v);
				}});
			}
			items.push({title: this.getString("unit_price_x", [this.currencyStore.currCurrency.symbol]), customSlot: 'item-total', price: this.price});
			return items;
		},
	},
	methods: {
		togglingPrice(isOpen) {
			if(!isOpen) {
				this.priceEdit = false;
			}
		},
		confirmPrice(number) {
			this.priceEdit = false;
			this.$emit('changed-price', number);
		},
		updatePrice() {
			if(this.userStore.checkOrderDiscountAllowed) {
				this.priceEdit = true;
			}
		}
	},
	emits: ["toggling-popup", "changed-quantity", "changed-price"]
}
</script>

<style scoped lang="scss">
.input-item {
	@media (max-width: 350px) {
		margin-left: auto;
	}
}
.item-total-container {
	display: flex;
	align-items: center;
	margin-left: auto;
	padding: 8px 12px;
	background-color: var(--color-bg-primary-2);
	border-radius: 13px;
	cursor: pointer;

	.item-price-full {
		font-size: 12px;
		color: var(--color-txt-1);
		text-decoration: line-through;
	}

	.item-total {
		font-size: 20px;
		color: $primary;
		font-weight: 700;
		user-select: none;
		cursor: pointer;
		padding: 4px;
	}
}
.item-textarea-container {
	gap: 10px;

	.input-item-textarea {
		margin-left: auto;
	}
}
</style>